<!-- <app-header></app-header> -->
    
    <!-- <app-sidebar *ngIf="showHead"></app-sidebar> -->

    <app-lab-sidebar *ngIf="showHead"></app-lab-sidebar>
    <app-samplecenter-sidebar *ngIf="showHead"></app-samplecenter-sidebar>
    <app-ministry-sidebar *ngIf="showHead"></app-ministry-sidebar>
    <app-airport-sidebar *ngIf="showHead"></app-airport-sidebar>

    <ng4-loading-spinner [threshold]="0" [timeout]="60000" [zIndex]="100000"> </ng4-loading-spinner>

    <router-outlet (activate)="onActivate($event)"></router-outlet>

    <button *ngIf="isShow" (click)="gotoTop()" id="scroll" class="default-bg " style="display: inline;"> <span class="fa fa-angle-up "></span> </button>


